import { getIsRTL, getWeekStartDay } from 'owa-publishedcalendar-settings';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import { mutator } from 'satcheljs';
import { default as initializeCalendarSurfaceOptions } from '../actions/initializeCalendarSurfaceOptions';

/**
 * Mutator that initializes calendar surface options
 */
mutator(initializeCalendarSurfaceOptions, actionMessage => {
    const store = getSurfaceStore();
    store.userOptions.isRTL = getIsRTL();
    store.userOptions.weekStartDay = getWeekStartDay();
});
